import React, { useState, useEffect, useRef, useCallback } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import { useAuth } from '../contexts/AuthContext';
import api from '../services/api';
import toast from 'react-hot-toast';
import Sidebar from '../components/Sidebar';

const MONTHS = ['Enero','Febrero','Marzo','Abril','Mayo','Junio','Julio','Agosto','Septiembre','Octubre','Noviembre','Diciembre'];

const PROCESS_STATUS_COLOR: any = {
  BORRADOR: '#94a3b8', REVISION_INTERNA: '#f59e0b', APROBADO_INTERNO: '#8b5cf6',
  REVISION_CLIENTE: '#2688c9', APROBADO: '#10b981', EN_PRODUCCION: '#0f2a4a', COMPLETADO: '#10b981',
};
const PROCESS_STATUS_LABEL: any = {
  BORRADOR: 'Borrador', REVISION_INTERNA: 'Rev. Interna', APROBADO_INTERNO: 'Apr. Interno',
  REVISION_CLIENTE: 'Rev. Cliente', APROBADO: 'Aprobado', EN_PRODUCCION: 'En Producción', COMPLETADO: 'Completado',
};
const CARD_TYPE_LABEL: any = {
  REEL: 'Reel', POST_ESTATICO: 'Post estático', CARRUSEL: 'Carrusel', ANIMACION: 'Animación', HISTORIA: 'Historia', VIDEO: 'Video',
};
const NETWORKS = ['Instagram','Facebook','TikTok','YouTube','LinkedIn'];
const PILARES = ['Educativo','Entretenimiento','Promocional','Testimonial','Marca','UGC'];
const FORMATOS: any = {
  REEL: ['1080x1920','720x1280'], POST_ESTATICO: ['1080x1080','1080x1350','1200x628'],
  CARRUSEL: ['1080x1080','1080x1350'], ANIMACION: ['1080x1080','1080x1920'], HISTORIA: ['1080x1920'],
};


// ── Modal crear proceso ──────────────────────────────────────────────
const CreateProcessModal: React.FC<{ brands: any[]; onClose: () => void; onCreated: (p: any) => void }> = ({ brands, onClose, onCreated }) => {
  const now = new Date();
  const [type, setType] = useState<'PARRILLA'|'CUADRO_MATERIALES'>('PARRILLA');
  const [form, setForm] = useState({ name: '', brandId: '', month: String(now.getMonth() + 1), year: String(now.getFullYear()), campaign: '', assignedUserId: '', materialsLink: '', totalPieces: '', deadline: '' });
  const [assignedUserIds, setAssignedUserIds] = useState<string[]>([]);
  const [modalUsers, setModalUsers] = useState<any[]>([]);
  useEffect(() => { api.get('/users').then(r => setModalUsers(Array.isArray(r.data)?r.data:[])).catch(()=>{}); }, []);
  const [saving, setSaving] = useState(false);
  const set = (k: string, v: string) => setForm(f => ({ ...f, [k]: v }));
  const toggleUser = (uid: string) => setAssignedUserIds(prev => prev.includes(uid) ? prev.filter(x=>x!==uid) : [...prev,uid]);

  const submit = async () => {
    if (!form.name || !form.brandId) { toast.error('Nombre y marca son requeridos'); return; }
    setSaving(true);
    try {
      const payload = { ...form, type, assignedUserIds };
      const r = await api.post('/processes', payload);
      onCreated(r.data);
      toast.success(type === 'CUADRO_MATERIALES' ? 'Cuadro de materiales creado' : 'Proceso creado');
      onClose();
    } catch (e: any) { toast.error(e?.response?.data?.error || 'Error al crear'); }
    finally { setSaving(false); }
  };

  return (
    <div style={{position:'fixed',inset:0,background:'rgba(0,0,0,0.45)',display:'flex',alignItems:'center',justifyContent:'center',zIndex:1000}} onClick={onClose}>
      <div style={{background:'white',borderRadius:'16px',padding:'28px',width:'460px',maxHeight:'85vh',overflowY:'auto'}} onClick={e=>e.stopPropagation()}>
        <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:'20px'}}>
          <div style={{fontSize:'16px',fontWeight:800,color:'#0f2a4a'}}>Nuevo Proceso</div>
          <button onClick={onClose} style={{background:'none',border:'none',fontSize:'20px',cursor:'pointer',color:'rgba(15,42,74,0.4)'}}>×</button>
        </div>
        {/* Selector de tipo */}
        <div style={{display:'flex',gap:'8px',marginBottom:'4px'}}>
          {(['PARRILLA','CUADRO_MATERIALES'] as const).map(t=>(
            <button key={t} onClick={()=>setType(t)} style={{flex:1,padding:'9px',borderRadius:'8px',border:`2px solid ${type===t?'#2688c9':'rgba(15,42,74,0.12)'}`,background:type===t?'rgba(38,136,201,0.07)':'white',color:type===t?'#2688c9':'rgba(15,42,74,0.5)',fontSize:'12px',fontWeight:700,cursor:'pointer',fontFamily:'"Montserrat",sans-serif',transition:'all 0.15s'}}>
              {t==='PARRILLA'?'📋 Parrilla':'📦 Cuadro de materiales'}
            </button>
          ))}
        </div>
        <div style={{display:'flex',flexDirection:'column',gap:'14px'}}>
          {/* Nombre */}
          <div>
            <label style={{fontSize:'11px',fontWeight:700,color:'rgba(15,42,74,0.5)',display:'block',marginBottom:'5px'}}>NOMBRE *</label>
            <input value={form.name} onChange={e=>set('name',e.target.value)} placeholder={type==='PARRILLA'?'Ej: Parrilla Julio 2026':'Ej: Cuadro Campaña Verano'}
              style={{width:'100%',padding:'9px 10px',borderRadius:'8px',border:'1px solid rgba(15,42,74,0.12)',fontSize:'13px',fontFamily:'"Montserrat",sans-serif',boxSizing:'border-box'}}/>
          </div>
          {/* Marca */}
          <div>
            <label style={{fontSize:'11px',fontWeight:700,color:'rgba(15,42,74,0.5)',display:'block',marginBottom:'5px'}}>MARCA *</label>
            <select value={form.brandId} onChange={e=>set('brandId',e.target.value)}
              style={{width:'100%',padding:'9px 10px',borderRadius:'8px',border:'1px solid rgba(15,42,74,0.12)',fontSize:'13px',fontFamily:'"Montserrat",sans-serif',boxSizing:'border-box'}}>
              <option value="">Selecciona marca</option>
              {brands.map(b=><option key={b.id} value={b.id}>{b.name}</option>)}
            </select>
          </div>
          {/* Campos PARRILLA */}
          {type === 'PARRILLA' && (<>
            <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:'10px'}}>
              <div>
                <label style={{fontSize:'11px',fontWeight:700,color:'rgba(15,42,74,0.5)',display:'block',marginBottom:'5px'}}>MES</label>
                <select value={form.month} onChange={e=>set('month',e.target.value)}
                  style={{width:'100%',padding:'9px 10px',borderRadius:'8px',border:'1px solid rgba(15,42,74,0.12)',fontSize:'13px',fontFamily:'"Montserrat",sans-serif',boxSizing:'border-box'}}>
                  {MONTHS.map((m,i)=><option key={i} value={String(i+1)}>{m}</option>)}
                </select>
              </div>
              <div>
                <label style={{fontSize:'11px',fontWeight:700,color:'rgba(15,42,74,0.5)',display:'block',marginBottom:'5px'}}>AÑO</label>
                <input type="number" value={form.year} onChange={e=>set('year',e.target.value)}
                  style={{width:'100%',padding:'9px 10px',borderRadius:'8px',border:'1px solid rgba(15,42,74,0.12)',fontSize:'13px',fontFamily:'"Montserrat",sans-serif',boxSizing:'border-box'}}/>
              </div>
            </div>
            <div>
              <label style={{fontSize:'11px',fontWeight:700,color:'rgba(15,42,74,0.5)',display:'block',marginBottom:'5px'}}>CAMPAÑA (opcional)</label>
              <input value={form.campaign} onChange={e=>set('campaign',e.target.value)} placeholder="Ej: Lanzamiento producto"
                style={{width:'100%',padding:'9px 10px',borderRadius:'8px',border:'1px solid rgba(15,42,74,0.12)',fontSize:'13px',fontFamily:'"Montserrat",sans-serif',boxSizing:'border-box'}}/>
            </div>
            <div>
              <label style={{fontSize:'11px',fontWeight:700,color:'rgba(15,42,74,0.5)',display:'block',marginBottom:'5px'}}>ASIGNAR A (opcional)</label>
              <select value={form.assignedUserId} onChange={e=>set('assignedUserId',e.target.value)}
                style={{width:'100%',padding:'9px 10px',borderRadius:'8px',border:'1px solid rgba(15,42,74,0.12)',fontSize:'13px',fontFamily:'"Montserrat",sans-serif',boxSizing:'border-box'}}>
                <option value="">— Sin asignar —</option>
                {modalUsers.map((u:any)=><option key={u.id} value={u.id}>{u.firstName} {u.lastName} ({u.role})</option>)}
              </select>
            </div>
          </>)}
          {/* Campos CUADRO_MATERIALES */}
          {type === 'CUADRO_MATERIALES' && (<>
            <div>
              <label style={{fontSize:'11px',fontWeight:700,color:'rgba(15,42,74,0.5)',display:'block',marginBottom:'5px'}}>LINK DEL CUADRO</label>
              <input value={form.materialsLink} onChange={e=>set('materialsLink',e.target.value)} placeholder="https://docs.google.com/..."
                style={{width:'100%',padding:'9px 10px',borderRadius:'8px',border:'1px solid rgba(15,42,74,0.12)',fontSize:'13px',fontFamily:'"Montserrat",sans-serif',boxSizing:'border-box'}}/>
            </div>
            <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:'10px'}}>
              <div>
                <label style={{fontSize:'11px',fontWeight:700,color:'rgba(15,42,74,0.5)',display:'block',marginBottom:'5px'}}>TOTAL DE PIEZAS</label>
                <input type="number" value={form.totalPieces} onChange={e=>set('totalPieces',e.target.value)} placeholder="0"
                  style={{width:'100%',padding:'9px 10px',borderRadius:'8px',border:'1px solid rgba(15,42,74,0.12)',fontSize:'13px',fontFamily:'"Montserrat",sans-serif',boxSizing:'border-box'}}/>
              </div>
              <div>
                <label style={{fontSize:'11px',fontWeight:700,color:'rgba(15,42,74,0.5)',display:'block',marginBottom:'5px'}}>FECHA LÍMITE</label>
                <input type="date" value={form.deadline} onChange={e=>set('deadline',e.target.value)}
                  style={{width:'100%',padding:'9px 10px',borderRadius:'8px',border:'1px solid rgba(15,42,74,0.12)',fontSize:'13px',fontFamily:'"Montserrat",sans-serif',boxSizing:'border-box'}}/>
              </div>
            </div>
            <div>
              <label style={{fontSize:'11px',fontWeight:700,color:'rgba(15,42,74,0.5)',display:'block',marginBottom:'6px'}}>ASIGNAR USUARIOS</label>
              <div style={{display:'flex',flexDirection:'column',gap:'6px',maxHeight:'150px',overflowY:'auto',border:'1px solid rgba(15,42,74,0.12)',borderRadius:'8px',padding:'8px'}}>
                {modalUsers.map((u:any)=>(
                  <label key={u.id} style={{display:'flex',alignItems:'center',gap:'8px',fontSize:'12px',color:'#0f2a4a',cursor:'pointer',padding:'4px'}}>
                    <input type="checkbox" checked={assignedUserIds.includes(u.id)} onChange={()=>toggleUser(u.id)}/>
                    {u.firstName} {u.lastName} <span style={{color:'rgba(15,42,74,0.4)',fontSize:'10px'}}>({u.role})</span>
                  </label>
                ))}
              </div>
            </div>
          </>)}
          <div style={{display:'flex',gap:'8px',marginTop:'4px'}}>
            <button onClick={onClose} style={{flex:1,padding:'10px',borderRadius:'8px',border:'1px solid #e2e8f0',background:'white',fontSize:'13px',fontWeight:600,cursor:'pointer',fontFamily:'"Montserrat",sans-serif'}}>Cancelar</button>
            <button onClick={submit} disabled={saving} style={{flex:2,padding:'10px',borderRadius:'8px',border:'none',background:'linear-gradient(135deg,#1e6fa8,#2688c9)',color:'white',fontSize:'13px',fontWeight:700,cursor:'pointer',fontFamily:'"Montserrat",sans-serif',opacity:saving?0.7:1}}>
              {saving ? 'Creando...' : type==='CUADRO_MATERIALES'?'Crear cuadro':'Crear proceso'}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};



// ── Íconos de tipo ────────────────────────────────────────────────────
const TypeIcon: React.FC<{ type: string; size?: number; color?: string }> = ({ type, size=20, color='#0f2a4a' }) => {
  const s = { width: size, height: size, fill: 'none', stroke: color, strokeWidth: 1.6, strokeLinecap: 'round' as any, strokeLinejoin: 'round' as any };
  switch(type) {
    case 'CARRUSEL': return <svg viewBox="0 0 24 24" style={s}><rect x="2" y="6" width="12" height="14" rx="2"/><rect x="16" y="8" width="5" height="12" rx="1.5" opacity=".5"/></svg>;
    case 'REEL': return <svg viewBox="0 0 24 24" style={s}><rect x="2" y="3" width="20" height="18" rx="2"/><line x1="2" y1="8" x2="22" y2="8"/><line x1="2" y1="16" x2="22" y2="16"/><line x1="8" y1="3" x2="8" y2="8"/><line x1="16" y1="3" x2="16" y2="8"/><line x1="8" y1="16" x2="8" y2="21"/><line x1="16" y1="16" x2="16" y2="21"/></svg>;
    case 'ANIMACION': return <svg viewBox="0 0 24 24" style={s}><path d="M12 2l2.4 7.4H22l-6.2 4.5 2.4 7.4L12 17l-6.2 4.3 2.4-7.4L2 9.4h7.6z"/></svg>;
    case 'VIDEO': return <svg viewBox="0 0 24 24" style={s}><rect x="2" y="5" width="15" height="14" rx="2"/><path d="M17 9l5-3v12l-5-3V9z"/></svg>;
    case 'HISTORIA': return <svg viewBox="0 0 24 24" style={s}><rect x="5" y="2" width="14" height="20" rx="3"/><line x1="5" y1="6" x2="19" y2="6"/><line x1="5" y1="18" x2="19" y2="18"/></svg>;
    default: return <svg viewBox="0 0 24 24" style={s}><rect x="3" y="3" width="18" height="18" rx="2"/><circle cx="8.5" cy="8.5" r="1.5"/><path d="M21 15l-5-5L5 21"/></svg>;
  }
};

// ── Documento estratégico ─────────────────────────────────────────────
const StrategyDocument: React.FC<{ process: any; isAdmin: boolean; userRole: string; userId: string; userName: string }> = ({ process, isAdmin, userRole, userId, userName }) => {
  const [content, setContent] = useState<string>('');
  const [open, setOpen] = useState(false);
  const [saving, setSaving] = useState(false);
  const [approving, setApproving] = useState(false);
  const [loaded, setLoaded] = useState(false);
  const [approval, setApproval] = useState<any>(null);
  const [comments, setComments] = useState<any[]>([]);
  const [newComment, setNewComment] = useState('');
  const [sendingComment, setSendingComment] = useState(false);
  const editorRef = useRef<HTMLDivElement>(null);
  const timerRef = useRef<any>(null);
  const FF = '"Montserrat",sans-serif';
  const ROLE_COLOR: any = { ADMIN:'#2688c9',CUENTAS:'#8b5cf6',CONTENIDO:'#10b981',DISENO:'#f59e0b',ESTRATEGIA:'#ef4444',CLIENTE:'#64748b' };

  useEffect(() => {
    if (open && !loaded) {
      api.get(`/processes/${process.id}`).then(r => {
        const doc = r.data.strategyDoc || '';
        setContent(doc);
        if (editorRef.current) editorRef.current.innerHTML = doc;
        if (r.data.strategyApprovedBy) {
          setApproval({ name: r.data.strategyApproverName, at: r.data.strategyApprovedAt });
        }
        setLoaded(true);
      }).catch(() => setLoaded(true));
      api.get(`/processes/${process.id}/strategy/comments`).then(r => setComments(r.data)).catch(() => {});
    }
  }, [open, loaded, process.id]);
  useEffect(() => {
    if (loaded && open && editorRef.current && content) {
      editorRef.current.innerHTML = content;
    }
  }, [loaded, open]);

  const toggleApprove = async () => {
    try {
      if (approval) {
        await api.delete(`/processes/${process.id}/strategy/approve`);
        setApproval(null);
        toast.success('Aprobación retirada');
      } else {
        const r = await api.put(`/processes/${process.id}/strategy/approve`, {});
        setApproval({ name: r.data.approverName, at: r.data.approvedAt });
        toast.success('Documento aprobado');
      }
    } catch { toast.error('Error al cambiar aprobación'); }
  };

  const addComment = async () => {
    if (!newComment.trim()) return;
    setSendingComment(true);
    try {
      const r = await api.post(`/processes/${process.id}/strategy/comments`, { content: newComment.trim() });
      setComments(prev => [...prev, r.data]);
      setNewComment('');
    } catch { toast.error('Error al comentar'); }
    finally { setSendingComment(false); }
  };

  const resolveComment = async (id: string, resolved: boolean) => {
    try {
      const r = await api.patch(`/processes/strategy/comments/${id}`, { resolved });
      setComments(prev => prev.map(c => c.id === id ? r.data : c));
    } catch { toast.error('Error'); }
  };

  const deleteComment = async (id: string) => {
    try {
      await api.delete(`/processes/strategy/comments/${id}`);
      setComments(prev => prev.filter(c => c.id !== id));
    } catch { toast.error('Error'); }
  };

  const saveContent = useCallback(async (html: string) => {
    setSaving(true);
    try { await api.put(`/processes/${process.id}/strategy`, { strategyDoc: html }); }
    catch { toast.error('Error al guardar'); }
    finally { setSaving(false); }
  }, [process.id]);

  const onInput = () => {
    if (!isAdmin || !editorRef.current) return;
    const html = editorRef.current.innerHTML;
    setContent(html);
    clearTimeout(timerRef.current);
    timerRef.current = setTimeout(() => saveContent(html), 1800);
  };

  const cmd = (command: string, value?: string) => {
    document.execCommand(command, false, value);
    editorRef.current?.focus();
    onInput();
  };

  const exportPdf = () => {
    const win = window.open('', '_blank');
    if (!win) return;
    win.document.write(`<!DOCTYPE html><html><head><title>${process.name} — Estrategia</title>
    <style>body{font-family:Georgia,serif;max-width:780px;margin:40px auto;padding:0 24px;color:#111;line-height:1.7}
    h1{font-size:22px}p.sub{color:#666;font-size:13px;margin-bottom:32px}</style></head><body>
    <h1>${process.name}</h1><p class="sub">Documento estratégico · ${MONTHS[(process.month||1)-1]} ${process.year}</p>
    <hr style="margin-bottom:24px">${content}
    <script>window.onload=()=>{window.print();}<\/script></body></html>`);
    win.document.close();
  };

  const BtnT: React.FC<{cmd: string; val?: string; title: string; children: any}> = (p) => (
    <button title={p.title} onMouseDown={e=>{e.preventDefault();cmd(p.cmd,p.val);}}
      style={{padding:'4px 8px',border:'none',background:'transparent',cursor:'pointer',fontSize:'13px',color:'#0f2a4a',borderRadius:'4px',fontFamily:FF,lineHeight:1}}>
      {p.children}
    </button>
  );

  return (
    <div style={{background:'white',borderRadius:'14px',border:'1px solid rgba(15,42,74,0.08)',marginBottom:'16px'}}>
      {/* Header colapsable */}
      <div onClick={() => setOpen(o => !o)}
        style={{display:'flex',justifyContent:'space-between',alignItems:'center',padding:'14px 18px',cursor:'pointer',userSelect:'none' as any}}>
        <div style={{display:'flex',alignItems:'center',gap:'10px'}}>
          <svg viewBox="0 0 24 24" width={18} height={18} fill="none" stroke="#2688c9" strokeWidth={1.8} strokeLinecap="round" strokeLinejoin="round"><path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/></svg>
          <span style={{fontSize:'13px',fontWeight:700,color:'#0f2a4a'}}>Documento estratégico</span>
          {!open && <span style={{fontSize:'10px',color: content.length>10 ? '#10b981':'#94a3b8',fontWeight:600}}>{content.length>10?'✓ Con contenido':'Vacío'}</span>}
        </div>
        <div style={{display:'flex',alignItems:'center',gap:'8px'}}>
          {open && saving && <span style={{fontSize:'10px',color:'#94a3b8'}}>Guardando...</span>}
          {open && !saving && content.length>10 && <span style={{fontSize:'10px',color:'#10b981'}}>✓ Guardado</span>}
          {open && <button onMouseDown={e=>{e.stopPropagation();e.preventDefault();exportPdf();}}
            style={{padding:'4px 10px',borderRadius:'6px',border:'1px solid rgba(38,136,201,0.2)',background:'rgba(38,136,201,0.06)',color:'#2688c9',fontSize:'11px',fontWeight:700,cursor:'pointer',fontFamily:FF}}>
            PDF</button>}
          <span style={{fontSize:'16px',color:'#94a3b8',display:'inline-block',transform:open?'rotate(180deg)':'rotate(0deg)',transition:'transform 0.2s'}}>▾</span>
        </div>
      </div>
      {/* Editor */}
      {open && (
        <div style={{borderTop:'1px solid rgba(15,42,74,0.07)'}}>
          {isAdmin && (
            <div style={{display:'flex',flexWrap:'wrap' as any,gap:'2px',padding:'8px 12px',borderBottom:'1px solid rgba(15,42,74,0.07)',background:'#fafbfc'}}>
              <select onMouseDown={e=>e.preventDefault()} onChange={e=>{cmd('formatBlock',e.target.value);(e.target as any).value='';}}
                style={{padding:'3px 6px',border:'1px solid rgba(15,42,74,0.12)',borderRadius:'4px',fontSize:'12px',fontFamily:FF,background:'white',cursor:'pointer'}}>
                <option value="">Estilo</option>
                <option value="h1">Título 1</option>
                <option value="h2">Título 2</option>
                <option value="h3">Título 3</option>
                <option value="p">Normal</option>
              </select>
              <div style={{width:'1px',background:'rgba(15,42,74,0.1)',margin:'0 4px'}}/>
              <BtnT cmd="bold" title="Negrita"><b>N</b></BtnT>
              <BtnT cmd="italic" title="Cursiva"><i>K</i></BtnT>
              <BtnT cmd="underline" title="Subrayado"><u>S</u></BtnT>
              <BtnT cmd="strikeThrough" title="Tachado"><s>T</s></BtnT>
              <div style={{width:'1px',background:'rgba(15,42,74,0.1)',margin:'0 4px'}}/>
              <BtnT cmd="justifyLeft" title="Izquierda">⬅</BtnT>
              <BtnT cmd="justifyCenter" title="Centro">↔</BtnT>
              <BtnT cmd="justifyRight" title="Derecha">➡</BtnT>
              <div style={{width:'1px',background:'rgba(15,42,74,0.1)',margin:'0 4px'}}/>
              <BtnT cmd="insertUnorderedList" title="Lista">• Lista</BtnT>
              <BtnT cmd="insertOrderedList" title="Numerada">1. Lista</BtnT>
              <div style={{width:'1px',background:'rgba(15,42,74,0.1)',margin:'0 4px'}}/>
              <label title="Color de texto" style={{display:'flex',alignItems:'center',gap:'3px',fontSize:'12px',color:'#0f2a4a',cursor:'pointer'}}>
                A <input type="color" defaultValue="#000000" onInput={e=>cmd('foreColor',(e.target as any).value)}
                  style={{width:'20px',height:'18px',border:'none',cursor:'pointer',padding:0}}/>
              </label>
              <label title="Resaltar" style={{display:'flex',alignItems:'center',gap:'3px',fontSize:'12px',color:'#0f2a4a',cursor:'pointer'}}>
                ▌ <input type="color" defaultValue="#ffff00" onInput={e=>cmd('backColor',(e.target as any).value)}
                  style={{width:'20px',height:'18px',border:'none',cursor:'pointer',padding:0}}/>
              </label>
              <div style={{width:'1px',background:'rgba(15,42,74,0.1)',margin:'0 4px'}}/>
              <BtnT cmd="removeFormat" title="Limpiar formato">✕</BtnT>
            </div>
          )}
          <div
            ref={editorRef}
            contentEditable={isAdmin}
            suppressContentEditableWarning
            onInput={onInput}
            style={{minHeight:'260px',padding:'20px 24px',outline:'none',fontSize:'14px',lineHeight:'1.8',color:'#0f2a4a',fontFamily:'Georgia,serif'}}
          />

          {/* Aprobación */}
          <div style={{borderTop:'1px solid rgba(15,42,74,0.07)',padding:'14px 20px',display:'flex',justifyContent:'space-between',alignItems:'center',background:'#fafbfc'}}>
            <div>
              {approval ? (
                <div style={{display:'flex',alignItems:'center',gap:'8px'}}>
                  <span style={{fontSize:'13px',color:'#10b981',fontWeight:700}}>✓ Aprobado por {approval.name}</span>
                  <span style={{fontSize:'11px',color:'rgba(15,42,74,0.4)'}}>{new Date(approval.at).toLocaleDateString('es-CO',{day:'numeric',month:'short',year:'numeric'})}</span>
                </div>
              ) : (
                <span style={{fontSize:'12px',color:'rgba(15,42,74,0.4)'}}>Sin aprobación aún</span>
              )}
            </div>
            <button onClick={toggleApprove}
              style={{padding:'7px 16px',borderRadius:'8px',border:'none',fontFamily:FF,fontSize:'12px',fontWeight:700,cursor:'pointer',
                background: approval ? '#fef2f2' : '#f0fdf4',
                color: approval ? '#ef4444' : '#10b981'}}>
              {approval ? 'Retirar aprobación' : '✓ Aprobar documento'}
            </button>
          </div>

          {/* Comentarios */}
          <div style={{borderTop:'1px solid rgba(15,42,74,0.07)',padding:'16px 20px'}}>
            <div style={{fontSize:'11px',fontWeight:700,color:'rgba(15,42,74,0.5)',letterSpacing:'0.8px',marginBottom:'12px'}}>COMENTARIOS Y CORRECCIONES</div>

            {/* Lista de comentarios */}
            <div style={{display:'flex',flexDirection:'column' as any,gap:'10px',marginBottom:'14px'}}>
              {comments.length === 0 && <div style={{fontSize:'12px',color:'rgba(15,42,74,0.3)',textAlign:'center',padding:'12px 0'}}>Sin comentarios aún</div>}
              {comments.map(c => (
                <div key={c.id} style={{borderRadius:'10px',border:`1px solid ${c.resolved?'rgba(16,185,129,0.2)':'rgba(15,42,74,0.1)'}`,padding:'12px 14px',background:c.resolved?'rgba(16,185,129,0.03)':'white',opacity:c.resolved?0.7:1}}>
                  <div style={{display:'flex',justifyContent:'space-between',alignItems:'flex-start',marginBottom:'6px'}}>
                    <div style={{display:'flex',alignItems:'center',gap:'8px'}}>
                      <div style={{width:'28px',height:'28px',borderRadius:'50%',background:ROLE_COLOR[c.userRole]||'#94a3b8',display:'flex',alignItems:'center',justifyContent:'center',fontSize:'11px',fontWeight:700,color:'white',flexShrink:0}}>
                        {c.userName.split(' ').map((n:string)=>n[0]).join('').slice(0,2).toUpperCase()}
                      </div>
                      <div>
                        <div style={{fontSize:'12px',fontWeight:700,color:'#0f2a4a'}}>{c.userName}</div>
                        <div style={{fontSize:'10px',color:'rgba(15,42,74,0.4)'}}>{new Date(c.createdAt).toLocaleDateString('es-CO',{day:'numeric',month:'short',hour:'2-digit',minute:'2-digit'})}</div>
                      </div>
                    </div>
                    <div style={{display:'flex',gap:'6px',alignItems:'center'}}>
                      {c.resolved && <span style={{fontSize:'10px',color:'#10b981',fontWeight:700}}>Resuelto</span>}
                      <button onClick={()=>resolveComment(c.id,!c.resolved)}
                        style={{padding:'3px 8px',borderRadius:'5px',border:'none',background:'rgba(15,42,74,0.06)',color:'rgba(15,42,74,0.5)',fontSize:'10px',cursor:'pointer',fontFamily:FF}}>
                        {c.resolved?'Reabrir':'Resolver'}
                      </button>
                      {(c.userId === userId || isAdmin) && (
                        <button onClick={()=>deleteComment(c.id)}
                          style={{padding:'3px 8px',borderRadius:'5px',border:'none',background:'#fef2f2',color:'#ef4444',fontSize:'10px',cursor:'pointer',fontFamily:FF}}>×</button>
                      )}
                    </div>
                  </div>
                  <div style={{fontSize:'13px',color:'#0f2a4a',lineHeight:'1.6',paddingLeft:'36px'}}>{c.content}</div>
                </div>
              ))}
            </div>

            {/* Nuevo comentario */}
            <div style={{display:'flex',gap:'8px',alignItems:'flex-end'}}>
              <div style={{width:'32px',height:'32px',borderRadius:'50%',background:ROLE_COLOR[userRole]||'#94a3b8',display:'flex',alignItems:'center',justifyContent:'center',fontSize:'11px',fontWeight:700,color:'white',flexShrink:0}}>
                {userName.split(' ').map((n:string)=>n[0]).join('').slice(0,2).toUpperCase()}
              </div>
              <textarea value={newComment} onChange={e=>setNewComment(e.target.value)}
                placeholder="Escribe un comentario o corrección..."
                rows={2}
                style={{flex:1,padding:'9px 12px',borderRadius:'8px',border:'1px solid rgba(15,42,74,0.12)',fontSize:'13px',fontFamily:FF,resize:'none',outline:'none',color:'#0f2a4a'}}
                onKeyDown={e=>{if(e.key==='Enter'&&e.metaKey)addComment();}}
              />
              <button onClick={addComment} disabled={sendingComment||!newComment.trim()}
                style={{padding:'9px 16px',borderRadius:'8px',border:'none',background:'linear-gradient(135deg,#1e6fa8,#2688c9)',color:'white',fontSize:'12px',fontWeight:700,cursor:'pointer',fontFamily:FF,opacity:(!newComment.trim()||sendingComment)?0.5:1,whiteSpace:'nowrap' as any}}>
                {sendingComment?'...':'Comentar'}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

// ── Ficha individual ─────────────────────────────────────────────────
const FichaCard: React.FC<{ card: any; isAdmin: boolean; userRole: string; onUpdate: (c: any) => void; onDelete: (id: string) => void; onApprove: (id: string) => void }> = ({ card, isAdmin, userRole, onUpdate, onDelete, onApprove }) => {
  const { user } = useAuth();
  const isAlejandra = (user?.email || '').toLowerCase() === 'contabilidadzoikagency@gmail.com';
  const [expanded, setExpanded] = useState(false);
  const [editing, setEditing] = useState(false);
  const [form, setForm] = useState({ ...card, publishDate: card.publishDate ? card.publishDate.slice(0,10) : '' });
  const [saving, setSaving] = useState(false);
  const [approving, setApproving] = useState(false);
  const [users, setUsers] = useState<any[]>([]);
  const set = (k: string, v: any) => setForm((f: any) => ({ ...f, [k]: v }));
  const showScript = ['REEL','ANIMACION'].includes(form.type);
  const hideFormato = ['REEL','ANIMACION','CARRUSEL','VIDEO','HISTORIA'].includes(form.type);
  const color = PROCESS_STATUS_COLOR[card.status] || '#94a3b8';

  useEffect(() => {
    api.get('/chat/team').then(r => setUsers(r.data)).catch(() => {});
  }, []);

  const save = async () => {
    setSaving(true);
    try {
      // Combinar publishDate + publishTime en UTC usando timezone del navegador
      const payload: any = { ...form };
      if (payload.publishDate) {
        const dateStr = payload.publishDate.slice(0, 10);
        const timeStr = payload.publishTime || '08:00';
        // new Date con string local usa el timezone del navegador automáticamente
        payload.publishDate = new Date(`${dateStr}T${timeStr}:00`).toISOString();
      }
      const r = await api.put(`/processes/cards/${card.id}`, payload);
      onUpdate(r.data);
      setEditing(false);
      toast.success('Ficha actualizada');
    } catch { toast.error('Error al guardar'); }
    finally { setSaving(false); }
  };

  const Field = ({ label, value }: { label: string; value: string }) => value ? (
    <div style={{marginBottom:'10px'}}>
      <div style={{fontSize:'10px',fontWeight:700,color:'rgba(15,42,74,0.4)',letterSpacing:'0.8px',marginBottom:'3px'}}>{label}</div>
      <div style={{fontSize:'13px',color:'#0f2a4a',lineHeight:'1.6',whiteSpace:'pre-wrap'}}>{value}</div>
    </div>
  ) : null;

  return (
    <div style={{background:'white',borderRadius:'14px',border:'1px solid rgba(15,42,74,0.08)',overflow:'hidden',boxShadow:'0 2px 8px rgba(15,42,74,0.06)'}}>
      {/* Header ficha */}
      <div style={{padding:'14px 16px',display:'flex',alignItems:'center',gap:'12px',cursor:'pointer',borderBottom:expanded?'1px solid rgba(15,42,74,0.07)':'none'}} onClick={()=>setExpanded(!expanded)}>
        <div style={{width:'36px',height:'36px',borderRadius:'10px',background:'rgba(38,136,201,0.08)',display:'flex',alignItems:'center',justifyContent:'center',flexShrink:0}}>
          <TypeIcon type={card.type} size={18} color="#2688c9"/>
        </div>
        <div style={{flex:1,minWidth:0}}>
          <div style={{fontSize:'13px',fontWeight:700,color:'#0f2a4a',overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap'}}>
            {(editing ? form.tema : card.tema) || CARD_TYPE_LABEL[card.type] || 'Nueva ficha'}
          </div>
          <div style={{fontSize:'11px',color:'rgba(15,42,74,0.4)',marginTop:'2px',display:'flex',gap:'8px'}}>
            <span>{CARD_TYPE_LABEL[card.type]}</span>
            {card.publishDate && <span>📅 {new Date(card.publishDate).toLocaleDateString('es-CO',{day:'2-digit',month:'short'})}</span>}
            {card.networks?.length > 0 && <span>{card.networks.join(' · ')}</span>}
            <span style={{padding:'2px 8px',borderRadius:'5px',background:`${color}18`,color,fontSize:'10px',fontWeight:700}}>{PROCESS_STATUS_LABEL[card.status]||card.status}</span>
          </div>
        </div>
        <div style={{display:'flex',alignItems:'center',gap:'8px'}}>
          <span style={{color:'rgba(15,42,74,0.3)',fontSize:'16px'}}>{expanded?'▲':'▼'}</span>
        </div>
      </div>

      {/* Contenido expandido */}
      {expanded && (
        <div style={{padding:'16px'}}>
          {!editing ? (
            <>
              <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:'0 20px'}}>
                <Field label="TEMA" value={card.tema}/>
                <Field label="PILAR" value={card.pilar}/>
                <Field label="OBJETIVO" value={card.objetivo}/>

                <Field label="PLAN" value={card.plan}/>
                <Field label="ASIGNACIÓN" value={card.asignacion}/>
                <Field label="PM/PC" value={card.pmPc}/>
                <Field label="LINK CONTENIDO" value={card.contentLink}/>
              </div>
              {card.copyIgFb && <Field label="COPY IG/FB" value={card.copyIgFb}/>}
              {card.copyTk && <Field label="COPY TK" value={card.copyTk}/>}
              {card.dialogo && <Field label="DIÁLOGO / SCRIPT" value={card.dialogo}/>}
              {['CARRUSEL','POST_ESTATICO'].includes(card.type) && card.carruselContent && <Field label={card.type==='CARRUSEL'?'CONTENIDO CARRUSEL':'TEXTO DE LA PIEZA'} value={card.carruselContent}/>}
              <div style={{display:'flex',gap:'8px',marginTop:'14px',justifyContent:'flex-end',flexWrap:'wrap'}}>
                {isAdmin && (<>
                  <button onClick={()=>onDelete(card.id)} style={{padding:'7px 14px',borderRadius:'8px',border:'none',background:'#fef2f2',color:'#ef4444',fontSize:'12px',fontWeight:700,cursor:'pointer',fontFamily:'"Montserrat",sans-serif'}}>Eliminar</button>
                  <button onClick={()=>setEditing(true)} style={{padding:'7px 14px',borderRadius:'8px',border:'none',background:'linear-gradient(135deg,#1e6fa8,#2688c9)',color:'white',fontSize:'12px',fontWeight:700,cursor:'pointer',fontFamily:'"Montserrat",sans-serif'}}>Editar ficha</button>
                </>)}
                {(userRole === 'CLIENTE' || userRole === 'ADMIN' || userRole === 'CUENTAS') && !isAlejandra && card.status === 'REVISION_CLIENTE' && (
                  <button onClick={async()=>{
                    setApproving(true);
                    try { await onApprove(card.id); }
                    finally { setApproving(false); }
                  }} disabled={approving} style={{padding:'7px 16px',borderRadius:'8px',border:'none',background:'linear-gradient(135deg,#059669,#10b981)',color:'white',fontSize:'12px',fontWeight:700,cursor:'pointer',fontFamily:'"Montserrat",sans-serif',opacity:approving?0.7:1}}>
                    {approving ? 'Aprobando...' : '✓ Aprobar ficha'}
                  </button>
                )}
              </div>
            </>
          ) : (
            <div style={{display:'flex',flexDirection:'column',gap:'12px'}}>
              {/* Tipo y redes */}
              <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:'10px'}}>
                <div>
                  <label style={{fontSize:'10px',fontWeight:700,color:'rgba(15,42,74,0.5)',display:'block',marginBottom:'4px'}}>TIPO</label>
                  <select value={form.type} onChange={e=>set('type',e.target.value)} style={{width:'100%',padding:'8px',borderRadius:'8px',border:'1px solid rgba(15,42,74,0.12)',fontSize:'12px',fontFamily:'"Montserrat",sans-serif',boxSizing:'border-box'}}>
                    {Object.entries(CARD_TYPE_LABEL).map(([k,v]:any)=><option key={k} value={k}>{v}</option>)}
                  </select>
                </div>
                <div>
                  <label style={{fontSize:'10px',fontWeight:700,color:'rgba(15,42,74,0.5)',display:'block',marginBottom:'4px'}}>FECHA PUBLICACIÓN</label>
                  <div style={{display:'flex',gap:'6px'}}>
                    <input type="date" value={form.publishDate} onChange={e=>set('publishDate',e.target.value)} style={{flex:2,padding:'8px',borderRadius:'8px',border:'1px solid rgba(15,42,74,0.12)',fontSize:'12px',fontFamily:'"Montserrat",sans-serif',boxSizing:'border-box'}}/>
                    <input type="time" value={(form as any).publishTime||'08:00'} onChange={e=>set('publishTime',e.target.value)} style={{flex:1,padding:'8px',borderRadius:'8px',border:'1px solid rgba(15,42,74,0.12)',fontSize:'12px',fontFamily:'"Montserrat",sans-serif',boxSizing:'border-box'}}/>
                  </div>
                </div>
              </div>
              {/* Redes */}
              <div>
                <label style={{fontSize:'10px',fontWeight:700,color:'rgba(15,42,74,0.5)',display:'block',marginBottom:'6px'}}>REDES</label>
                <div style={{display:'flex',gap:'8px',flexWrap:'wrap'}}>
                  {NETWORKS.map(n=>(
                    <label key={n} style={{display:'flex',alignItems:'center',gap:'4px',fontSize:'12px',color:'#0f2a4a',cursor:'pointer'}}>
                      <input type="checkbox" checked={form.networks?.includes(n)} onChange={e=>{
                        const nets = form.networks||[];
                        set('networks', e.target.checked ? [...nets,n] : nets.filter((x:string)=>x!==n));
                      }}/>{n}
                    </label>
                  ))}
                </div>
              </div>
              {/* Campos de texto */}
              {[['tema','TEMA'],['objetivo','OBJETIVO'],['pilar','PILAR'],['plan','PLAN'],['pmPc','PM/PC'],['contentLink','LINK CONTENIDO']].map(([k,label])=>(
                <div key={k}>
                  <label style={{fontSize:'10px',fontWeight:700,color:'rgba(15,42,74,0.5)',display:'block',marginBottom:'4px'}}>{label}</label>
                  <input value={(form as any)[k]||''} onChange={e=>set(k,e.target.value)}
                    style={{width:'100%',padding:'8px',borderRadius:'8px',border:'1px solid rgba(15,42,74,0.12)',fontSize:'12px',fontFamily:'"Montserrat",sans-serif',boxSizing:'border-box'}}/>
                </div>
              ))}

              {/* Asignación — selector de usuarios */}
              <div>
                <label style={{fontSize:'10px',fontWeight:700,color:'rgba(15,42,74,0.5)',display:'block',marginBottom:'4px'}}>ASIGNACIÓN</label>
                <select value={form.assignedUserId||''} onChange={e=>{
                  const u = users.find((u:any)=>u.id===e.target.value);
                  set('assignedUserId', e.target.value);
                  set('asignacion', u ? `${u.firstName} ${u.lastName}` : '');
                }} style={{width:'100%',padding:'8px',borderRadius:'8px',border:'1px solid rgba(15,42,74,0.12)',fontSize:'12px',fontFamily:'"Montserrat",sans-serif',boxSizing:'border-box',background:'white'}}>
                  <option value="">— Sin asignar —</option>
                  {users.map((u:any)=>(
                    <option key={u.id} value={u.id}>{u.firstName} {u.lastName} ({u.role})</option>
                  ))}
                </select>
              </div>
              {/* Copies */}
              {[['copyIgFb','COPY IG/FB'],['copyTk','COPY TK']].map(([k,label])=>(
                <div key={k}>
                  <label style={{fontSize:'10px',fontWeight:700,color:'rgba(15,42,74,0.5)',display:'block',marginBottom:'4px'}}>{label}</label>
                  <textarea value={(form as any)[k]||''} onChange={e=>set(k,e.target.value)} rows={4}
                    style={{width:'100%',padding:'8px',borderRadius:'8px',border:'1px solid rgba(15,42,74,0.12)',fontSize:'12px',fontFamily:'"Montserrat",sans-serif',resize:'vertical',boxSizing:'border-box'}}/>
                </div>
              ))}
              {showScript && (
                <div>
                  <label style={{fontSize:'10px',fontWeight:700,color:'rgba(15,42,74,0.5)',display:'block',marginBottom:'4px'}}>DIÁLOGO / SCRIPT</label>
                  <textarea value={form.dialogo||''} onChange={e=>set('dialogo',e.target.value)} rows={6}
                    style={{width:'100%',padding:'8px',borderRadius:'8px',border:'1px solid rgba(15,42,74,0.12)',fontSize:'12px',fontFamily:'"Montserrat",sans-serif',resize:'vertical',boxSizing:'border-box'}}/>
                </div>
              )}
              {['CARRUSEL','POST_ESTATICO'].includes(form.type) && (
                <div>
                  <label style={{fontSize:'10px',fontWeight:700,color:'rgba(15,42,74,0.5)',display:'block',marginBottom:'4px'}}>{form.type==='CARRUSEL'?'CONTENIDO CARRUSEL':'TEXTO DE LA PIEZA'}</label>
                  <textarea value={form.carruselContent||''} onChange={e=>set('carruselContent',e.target.value)} rows={5} placeholder={form.type==='CARRUSEL'?'Escribe el contenido de cada lámina...':'Escribe el texto que irá en la pieza gráfica...'}
                    style={{width:'100%',padding:'8px',borderRadius:'8px',border:'1px solid rgba(15,42,74,0.12)',fontSize:'12px',fontFamily:'"Montserrat",sans-serif',resize:'vertical',boxSizing:'border-box'}}/>
                </div>
              )}
              <div style={{display:'flex',gap:'8px',justifyContent:'flex-end'}}>
                <button onClick={()=>setEditing(false)} style={{padding:'8px 16px',borderRadius:'8px',border:'1px solid #e2e8f0',background:'white',fontSize:'12px',fontWeight:600,cursor:'pointer',fontFamily:'"Montserrat",sans-serif'}}>Cancelar</button>
                <button onClick={save} disabled={saving} style={{padding:'8px 16px',borderRadius:'8px',border:'none',background:'linear-gradient(135deg,#1e6fa8,#2688c9)',color:'white',fontSize:'12px',fontWeight:700,cursor:'pointer',fontFamily:'"Montserrat",sans-serif',opacity:saving?0.7:1}}>
                  {saving?'Guardando...':'Guardar cambios'}
                </button>
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
};


// ── Vista cuadro de materiales ───────────────────────────────────────
const MaterialsBoardDetail: React.FC<{ process: any; isAdmin: boolean; onBack: () => void; onDelete?: () => void }> = ({ process, isAdmin, onBack, onDelete }) => {
  const { user } = useAuth();
  const isAlejandra = (user?.email || '').toLowerCase() === 'contabilidadzoikagency@gmail.com';
  const [pieces, setPieces] = useState<any[]>([]);
  const [users, setUsers] = useState<any[]>([]);

  useEffect(() => {
    api.get(`/pieces?materialsBoardId=${process.id}`).then(r => setPieces(r.data)).catch(()=>{});
    api.get('/chat/team').then(r => setUsers(r.data)).catch(()=>{});
  }, [process.id]);

  const assignedIds: string[] = (() => { try { return JSON.parse(process.assignedUserIds || '[]'); } catch { return []; } })();
  const assignedUsers = users.filter(u => assignedIds.includes(u.id));
  // Función para contar diapositivas reales (carruseles cuentan cada foto, videos Genius cuentan x2)
  const getPieceSlidesCount = (p: any) => {
    const isGenius = p.brand?.name?.toLowerCase().includes('genius') || process.brand?.name?.toLowerCase().includes('genius');
    const isVid = ['VIDEO', 'ANIMACION', 'REEL'].includes(p.type) || ['VIDEO', 'ANIMACION', 'REEL'].includes(p.contentType);

    let count = 1;
    if (p.type === 'CARRUSEL' && Array.isArray(p.files) && p.files.length > 0) {
      count = p.files.length;
    } else if (isGenius && isVid) {
      count = 2; // Regla Genius x2
    }
    return count;
  };

  const totalSlidesSubidas = pieces.reduce((sum, p) => sum + getPieceSlidesCount(p), 0);
  const totalSlidesAprobadas = pieces.filter(p => p.status === 'APROBADO' || p.status === 'SUBIDO').reduce((sum, p) => sum + getPieceSlidesCount(p), 0);
  const totalSlidesPendientes = totalSlidesSubidas - totalSlidesAprobadas;
  const approved = totalSlidesAprobadas;
  const total = process.totalPieces || 0;
  const progress = total > 0 ? Math.round((approved / total) * 100) : 0;
  const deadline = process.deadline ? new Date(process.deadline) : null;
  const daysLeft = deadline ? Math.ceil((deadline.getTime() - Date.now()) / 86400000) : null;

  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
  const [deleting, setDeleting] = useState(false);
  const [showEdit, setShowEdit] = useState(false);
  const [editForm, setEditForm] = useState({
    name: process.name,
    totalPieces: process.totalPieces || 0,
    deadline: process.deadline ? process.deadline.slice(0, 10) : '',
    materialsLink: process.materialsLink || '',
    assignedUserIds: assignedIds || [],
    reassignPieces: true
  });
  const [saving, setSaving] = useState(false);
  const handleDelete = async () => {
    setDeleting(true);
    try { await api.delete(`/processes/${process.id}`); if(onDelete) onDelete(); }
    catch { toast.error('Error al eliminar'); }
    finally { setDeleting(false); }
  };
  const handleEdit = async () => {
    setSaving(true);
    try {
      const r = await api.put(`/processes/${process.id}`, {
        name: editForm.name,
        totalPieces: Number(editForm.totalPieces),
        deadline: editForm.deadline || null,
        materialsLink: editForm.materialsLink,
        assignedUserIds: editForm.assignedUserIds,
        reassignPieces: editForm.reassignPieces
      });
      setShowEdit(false);
      toast.success('Cuadro y diseñador responsable actualizados');
      // Recargar página para reflejar cambios en equipo y métricas
      window.location.reload();
    } catch { toast.error('Error al guardar'); }
    finally { setSaving(false); }
  };
  const [approvingAll, setApprovingAll] = useState(false);

  const handleApproveAll = async () => {
    const unapprovedCount = pieces.filter(p => p.status !== 'APROBADO').length;
    const confirmMsg = unapprovedCount > 0
      ? `¿Aprobar todas las ${pieces.length} piezas de este cuadro de material (${unapprovedCount} pendientes)? Se actualizarán las fichas, el proceso, producción y las métricas del equipo.`
      : `¿Re-aprobar todas las ${pieces.length} piezas de este cuadro de material?`;

    if (!window.confirm(confirmMsg)) return;

    setApprovingAll(true);
    toast.loading('Aprobando piezas y actualizando métricas...', { id: 'approve-all' });

    try {
      const res = await api.post(`/processes/${process.id}/approve-all`);
      toast.success(res.data?.message || '¡Todas las piezas fueron aprobadas con éxito!', { id: 'approve-all' });
      
      // Recargar piezas vinculadas inmediatamente
      const r = await api.get(`/pieces?materialsBoardId=${process.id}`);
      setPieces(r.data);
    } catch (err: any) {
      toast.error('Error al aprobar todas las piezas', { id: 'approve-all' });
    } finally {
      setApprovingAll(false);
    }
  };

  const STATUS_LABEL: Record<string,string> = {
    REVISION_INTERNA: 'Rev. Interna', REVISION_CLIENTE: 'Rev. Cliente',
    APROBADO: 'Aprobado', SUBIDO: 'Subido',
  };
  const STATUS_COLOR: Record<string,string> = {
    REVISION_INTERNA: '#f59e0b', REVISION_CLIENTE: '#2688c9',
    APROBADO: '#10b981', SUBIDO: '#10b981',
  };

  return (<>
    <div style={{minHeight:'100vh',background:'#f0f4f8',padding:'24px'}}>
      {/* Header */}
      <div style={{display:'flex',alignItems:'center',gap:'16px',marginBottom:'24px'}}>
        <button onClick={onBack} style={{background:'white',border:'1px solid rgba(15,42,74,0.12)',borderRadius:'8px',padding:'8px 12px',cursor:'pointer',fontSize:'13px',fontWeight:600,color:'#0f2a4a',fontFamily:'"Montserrat",sans-serif'}}>← Volver</button>
        <div>
          <h2 style={{margin:0,fontSize:'20px',fontWeight:800,color:'#0f2a4a'}}>{process.name}</h2>
          <div style={{fontSize:'12px',color:'rgba(15,42,74,0.5)',marginTop:'2px'}}>{process.brand?.name} · Cuadro de materiales</div>
        </div>
        {process.materialsLink && (
          <a href={process.materialsLink} target="_blank" rel="noreferrer" style={{marginLeft:'auto',padding:'9px 18px',borderRadius:'9px',border:'none',background:'linear-gradient(135deg,#1e6fa8,#2688c9)',color:'white',fontSize:'12px',fontWeight:700,cursor:'pointer',textDecoration:'none',fontFamily:'"Montserrat",sans-serif'}}>
            Ver cuadro de materiales ↗
          </a>
        )}
        {isAdmin && !isAlejandra && (<>
          <button
            onClick={handleApproveAll}
            disabled={approvingAll || pieces.length === 0}
            style={{
              padding: '8px 18px',
              borderRadius: '8px',
              border: 'none',
              background: 'linear-gradient(135deg, #10b981 0%, #059669 100%)',
              color: 'white',
              fontSize: '12px',
              fontWeight: 800,
              cursor: pieces.length === 0 ? 'not-allowed' : 'pointer',
              fontFamily: '"Montserrat", sans-serif',
              boxShadow: '0 2px 8px rgba(16, 185, 129, 0.25)',
              marginLeft: process.materialsLink ? '0' : 'auto',
              display: 'flex',
              alignItems: 'center',
              gap: '6px'
            }}
          >
            {approvingAll ? 'Aprobando todo...' : `✓ Aprobar todas las piezas (${pieces.length})`}
          </button>
          <button onClick={()=>setShowEdit(true)} style={{padding:'7px 14px',borderRadius:'8px',border:'1px solid rgba(15,42,74,0.12)',background:'white',color:'#0f2a4a',fontSize:'12px',fontWeight:600,cursor:'pointer',fontFamily:'"Montserrat",sans-serif'}}>✏️ Editar</button>
          <button onClick={()=>setShowDeleteConfirm(true)} style={{padding:'7px 14px',borderRadius:'8px',border:'none',background:'#fef2f2',color:'#ef4444',fontSize:'12px',fontWeight:700,cursor:'pointer',fontFamily:'"Montserrat",sans-serif'}}>🗑️ Eliminar</button>
        </>)}
        {isAdmin && isAlejandra && (
          <div style={{
            marginLeft: process.materialsLink ? '0' : 'auto',
            padding: '8px 16px',
            borderRadius: '10px',
            background: 'rgba(2,132,199,0.08)',
            border: '1px solid rgba(2,132,199,0.2)',
            color: '#0284c7',
            fontSize: '12px',
            fontWeight: 800,
            display: 'flex',
            alignItems: 'center',
            gap: '6px',
            fontFamily: '"Montserrat", sans-serif'
          }}>
            <span>📊 Modo Contabilidad & Métricas — Aprobación operativa asignada a Dirección/Producción</span>
          </div>
        )}
      </div>

      {/* Stats cards contando diapositivas reales */}
      <div style={{display:'grid',gridTemplateColumns:'repeat(4,1fr)',gap:'14px',marginBottom:'20px'}}>
        {[
          { label: 'Total estimado', value: total, sub: 'piezas esperadas' },
          { label: 'Diapositivas Subidas', value: totalSlidesSubidas, sub: `${pieces.length} fichas/carpetas` },
          { label: 'Diapositivas Aprobadas', value: totalSlidesAprobadas, sub: 'listas para publicar' },
          { label: 'Pendientes de Aprobación', value: totalSlidesPendientes, sub: 'en revisión' },
        ].map(s => (
          <div key={s.label} style={{background:'white',borderRadius:'12px',padding:'16px',boxShadow:'0 2px 8px rgba(15,42,74,0.06)'}}>
            <div style={{fontSize:'11px',fontWeight:700,color:'rgba(15,42,74,0.4)',marginBottom:'6px'}}>{s.label.toUpperCase()}</div>
            <div style={{fontSize:'28px',fontWeight:800,color:'#0f2a4a'}}>{s.value}</div>
            <div style={{fontSize:'10px',color:'#64748b',marginTop:'2px'}}>{s.sub}</div>
          </div>
        ))}
      </div>


      {/* Progreso y deadline */}
      <div style={{background:'white',borderRadius:'12px',padding:'20px',marginBottom:'16px',boxShadow:'0 2px 8px rgba(15,42,74,0.06)'}}>
        <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:'10px'}}>
          <div style={{fontSize:'12px',fontWeight:700,color:'rgba(15,42,74,0.5)'}}>PROGRESO</div>
          <div style={{fontSize:'12px',fontWeight:700,color:'#0f2a4a'}}>{approved}/{total} aprobadas ({progress}%)</div>
        </div>
        <div style={{height:'8px',borderRadius:'4px',background:'rgba(15,42,74,0.08)',overflow:'hidden'}}>
          <div style={{height:'100%',borderRadius:'4px',background:'linear-gradient(90deg,#2688c9,#10b981)',width:`${progress}%`,transition:'width 0.5s'}}/>
        </div>
        {deadline && (
          <div style={{marginTop:'12px',fontSize:'12px',color: daysLeft! < 0 ? '#ef4444' : daysLeft! <= 3 ? '#f59e0b' : 'rgba(15,42,74,0.5)'}}>
            📅 Fecha límite: {deadline.toLocaleDateString('es-CO',{day:'numeric',month:'long',year:'numeric'})}
            {daysLeft !== null && <span style={{fontWeight:700,marginLeft:'8px'}}>{daysLeft < 0 ? `Venció hace ${Math.abs(daysLeft)} días` : daysLeft === 0 ? 'Vence hoy' : `${daysLeft} días restantes`}</span>}
          </div>
        )}
        {assignedUsers.length > 0 && (
          <div style={{marginTop:'12px',display:'flex',gap:'8px',flexWrap:'wrap'}}>
            <span style={{fontSize:'11px',fontWeight:700,color:'rgba(15,42,74,0.4)'}}>EQUIPO:</span>
            {assignedUsers.map(u => (
              <span key={u.id} style={{fontSize:'11px',padding:'3px 10px',borderRadius:'20px',background:'rgba(38,136,201,0.1)',color:'#2688c9',fontWeight:600}}>{u.firstName} {u.lastName}</span>
            ))}
          </div>
        )}
      </div>

      {/* Lista de piezas */}
      <div style={{background:'white',borderRadius:'12px',padding:'20px',boxShadow:'0 2px 8px rgba(15,42,74,0.06)'}}>
        <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:'14px'}}>
          <div style={{fontSize:'12px',fontWeight:700,color:'rgba(15,42,74,0.5)'}}>DIAPOSITIVAS VINCULADAS: {totalSlidesSubidas} diapositivas ({pieces.length} fichas)</div>
          {isAdmin && !isAlejandra && pieces.length > 0 && (
            <button
              onClick={handleApproveAll}
              disabled={approvingAll}
              style={{
                padding: '6px 14px',
                borderRadius: '6px',
                border: '1px solid #10b981',
                background: '#f0fdf4',
                color: '#15803d',
                fontSize: '11px',
                fontWeight: 800,
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                gap: '6px'
              }}
            >
              {approvingAll ? 'Aprobando...' : `✓ Aprobar todas (${pieces.length})`}
            </button>
          )}
        </div>
        {pieces.length === 0 ? (
          <div style={{textAlign:'center',padding:'32px',color:'rgba(15,42,74,0.3)',fontSize:'13px'}}>
            Aún no hay piezas vinculadas a este cuadro.<br/>Los diseñadores pueden vincularlas al subir contenido.
          </div>
        ) : (
          <div style={{display:'flex',flexDirection:'column',gap:'8px'}}>
            {pieces.map(p => (
              <div key={p.id} style={{display:'flex',alignItems:'center',gap:'12px',padding:'10px 14px',borderRadius:'8px',border:'1px solid rgba(15,42,74,0.07)'}}>
                {p.fileUrl && <img src={p.fileUrl} alt="" style={{width:'40px',height:'40px',borderRadius:'6px',objectFit:'cover',flexShrink:0}}/>}
                {!p.fileUrl && <div style={{width:'40px',height:'40px',borderRadius:'6px',background:'rgba(15,42,74,0.06)',flexShrink:0}}/>}
                <div style={{flex:1}}>
                  <div style={{fontSize:'13px',fontWeight:700,color:'#0f2a4a',display:'flex',alignItems:'center',gap:'8px'}}>
                    {p.title}
                    <span style={{fontSize:'10px',fontWeight:800,background:'#eff6ff',color:'#0070f3',padding:'2px 8px',borderRadius:'6px'}}>
                      {getPieceSlidesCount(p)} diapositiva(s)
                    </span>
                  </div>
                  <div style={{fontSize:'11px',color:'rgba(15,42,74,0.4)',marginTop:'2px'}}>{p.brand?.name} · {p.type}</div>
                </div>
                <span style={{padding:'3px 10px',borderRadius:'6px',background:`${STATUS_COLOR[p.status]||'#94a3b8'}18`,color:STATUS_COLOR[p.status]||'#94a3b8',fontSize:'10px',fontWeight:700}}>
                  {STATUS_LABEL[p.status]||p.status}
                </span>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
    {showDeleteConfirm && (
      <div style={{position:'fixed',inset:0,background:'rgba(0,0,0,0.45)',display:'flex',alignItems:'center',justifyContent:'center',zIndex:1000}} onClick={()=>setShowDeleteConfirm(false)}>
        <div style={{background:'white',borderRadius:'16px',padding:'28px',width:'360px',textAlign:'center'}} onClick={e=>e.stopPropagation()}>
          <div style={{fontSize:'36px',marginBottom:'12px'}}>🗑️</div>
          <h2 style={{margin:'0 0 8px',fontSize:'17px',fontWeight:800,color:'#111'}}>Eliminar cuadro</h2>
          <p style={{margin:'0 0 20px',fontSize:'13px',color:'#6b7280'}}>¿Seguro que deseas eliminar <strong>{process.name}</strong>?</p>
          <div style={{display:'flex',gap:'10px',justifyContent:'center'}}>
            <button onClick={handleDelete} disabled={deleting} style={{padding:'10px 24px',borderRadius:'9px',border:'none',background:'#ef4444',color:'white',fontWeight:700,fontSize:'13px',cursor:'pointer',fontFamily:'inherit',opacity:deleting?0.7:1}}>{deleting?'Eliminando...':'Sí, eliminar'}</button>
            <button onClick={()=>setShowDeleteConfirm(false)} style={{padding:'10px 24px',borderRadius:'9px',border:'1px solid #e2e8f0',background:'white',color:'#6b7280',fontWeight:600,fontSize:'13px',cursor:'pointer',fontFamily:'inherit'}}>Cancelar</button>
          </div>
        </div>
      </div>
    )}
    {showEdit && (
      <div style={{position:'fixed',inset:0,background:'rgba(0,0,0,0.45)',display:'flex',alignItems:'center',justifyContent:'center',zIndex:1000}} onClick={()=>setShowEdit(false)}>
        <div style={{background:'white',borderRadius:'16px',padding:'28px',width:'400px'}} onClick={e=>e.stopPropagation()}>
          <h2 style={{margin:'0 0 20px',fontSize:'16px',fontWeight:800,color:'#0f2a4a'}}>Editar cuadro de materiales</h2>
          <div style={{display:'flex',flexDirection:'column',gap:'12px'}}>
            <div>
              <label style={{fontSize:'10px',fontWeight:700,color:'rgba(15,42,74,0.5)',display:'block',marginBottom:'4px'}}>NOMBRE</label>
              <input value={editForm.name} onChange={e=>setEditForm(f=>({...f,name:e.target.value}))} style={{width:'100%',padding:'9px',borderRadius:'8px',border:'1px solid rgba(15,42,74,0.12)',fontSize:'13px',fontFamily:'"Montserrat",sans-serif',boxSizing:'border-box'}}/>
            </div>
            <div>
              <label style={{fontSize:'10px',fontWeight:700,color:'rgba(15,42,74,0.5)',display:'block',marginBottom:'4px'}}>TOTAL PIEZAS</label>
              <input type="number" value={editForm.totalPieces} onChange={e=>setEditForm(f=>({...f,totalPieces:Number(e.target.value)}))} style={{width:'100%',padding:'9px',borderRadius:'8px',border:'1px solid rgba(15,42,74,0.12)',fontSize:'13px',fontFamily:'"Montserrat",sans-serif',boxSizing:'border-box'}}/>
            </div>
            <div>
              <label style={{fontSize:'10px',fontWeight:700,color:'rgba(15,42,74,0.5)',display:'block',marginBottom:'4px'}}>FECHA LÍMITE</label>
              <input type="date" value={editForm.deadline} onChange={e=>setEditForm(f=>({...f,deadline:e.target.value}))} style={{width:'100%',padding:'9px',borderRadius:'8px',border:'1px solid rgba(15,42,74,0.12)',fontSize:'13px',fontFamily:'"Montserrat",sans-serif',boxSizing:'border-box'}}/>
            </div>
            <div>
              <label style={{fontSize:'10px',fontWeight:700,color:'rgba(15,42,74,0.5)',display:'block',marginBottom:'4px'}}>LINK CUADRO</label>
              <input value={editForm.materialsLink} onChange={e=>setEditForm(f=>({...f,materialsLink:e.target.value}))} placeholder="https://..." style={{width:'100%',padding:'9px',borderRadius:'8px',border:'1px solid rgba(15,42,74,0.12)',fontSize:'13px',fontFamily:'"Montserrat",sans-serif',boxSizing:'border-box'}}/>
            </div>
            <div>
              <label style={{fontSize:'10px',fontWeight:700,color:'rgba(15,42,74,0.5)',display:'block',marginBottom:'4px'}}>DISEÑADOR / RESPONSABLE</label>
              <select
                value={editForm.assignedUserIds[0] || ''}
                onChange={e => {
                  const uid = e.target.value;
                  setEditForm(f => ({ ...f, assignedUserIds: uid ? [uid] : [] }));
                }}
                style={{width:'100%',padding:'9px',borderRadius:'8px',border:'1.5px solid rgba(15,42,74,0.12)',fontSize:'13px',fontWeight:600,fontFamily:'"Montserrat",sans-serif',boxSizing:'border-box',background:'white'}}
              >
                <option value="">-- Sin asignar --</option>
                {users.map((u: any) => (
                  <option key={u.id} value={u.id}>{u.firstName} {u.lastName} ({u.role})</option>
                ))}
              </select>
              <label style={{display:'flex',alignItems:'center',gap:'8px',fontSize:'12px',color:'#0f2a4a',marginTop:'8px',cursor:'pointer',fontWeight:600}}>
                <input
                  type="checkbox"
                  checked={editForm.reassignPieces}
                  onChange={e => setEditForm(f => ({ ...f, reassignPieces: e.target.checked }))}
                />
                Reasignar también todas las piezas subidas a este diseñador
              </label>
            </div>
          </div>
          <div style={{display:'flex',gap:'10px',justifyContent:'flex-end',marginTop:'20px'}}>
            <button onClick={()=>setShowEdit(false)} style={{padding:'9px 20px',borderRadius:'9px',border:'1px solid #e2e8f0',background:'white',color:'#6b7280',fontWeight:600,fontSize:'13px',cursor:'pointer',fontFamily:'inherit'}}>Cancelar</button>
            <button onClick={handleEdit} disabled={saving} style={{padding:'9px 24px',borderRadius:'9px',border:'none',background:'linear-gradient(135deg,#1e6fa8,#2688c9)',color:'white',fontWeight:700,fontSize:'13px',cursor:'pointer',fontFamily:'inherit',opacity:saving?0.7:1}}>{saving?'Guardando...':'Guardar'}</button>
          </div>
        </div>
      </div>
    )}
  </>);
};

// ── Vista detalle de proceso ─────────────────────────────────────────
const ProcessDetail: React.FC<{ process: any; isAdmin: boolean; userRole: string; onBack: () => void; onUpdated: (p: any) => void; onDelete?: () => void; openCardId?: string }> = ({ process, isAdmin, userRole, onBack, onUpdated, onDelete, openCardId }) => {
  const { user } = useAuth();
  const isAlejandra = (user?.email || '').toLowerCase() === 'contabilidadzoikagency@gmail.com';
  const userId = (user as any)?.id || (user as any)?.userId || '';
  const userName = user ? `${user.firstName} ${user.lastName}` : 'Usuario';
  const [cards, setCards] = useState<any[]>(process.cards || []);
  useEffect(()=>{
    if(!openCardId||cards.length===0)return;
    const t=setTimeout(()=>{
      const el=document.getElementById('card-'+openCardId);
      if(el){el.scrollIntoView({behavior:'smooth',block:'center'});el.style.transition='box-shadow 0.3s';el.style.boxShadow='0 0 0 3px #2688c9';setTimeout(()=>{el.style.boxShadow='';},2500);}
    },400);
    return()=>clearTimeout(t);
  },[openCardId,cards.length]);
  const [adding, setAdding] = useState(false);
  const [approving, setApproving] = useState(false);
  const [scheduling, setScheduling] = useState(false);
  const [status, setStatus] = useState(process.status);
  const color = PROCESS_STATUS_COLOR[status] || '#94a3b8';
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
  const [deleting, setDeleting] = useState(false);
  const [showEdit, setShowEdit] = useState(false);
  const [editForm, setEditForm] = useState({ name: process.name, campaign: process.campaign||'', month: process.month, year: process.year });
  const [saving, setSaving] = useState(false);
  const [brands, setBrands] = useState<any[]>([]);
  useEffect(() => { api.get('/brands').then(r => setBrands(r.data)).catch(()=>{}); }, []);
  const handleDelete = async () => {
    setDeleting(true);
    try { await api.delete(`/processes/${process.id}`); if(onDelete) onDelete(); }
    catch { toast.error('Error al eliminar'); }
    finally { setDeleting(false); }
  };
  const handleEdit = async () => {
    setSaving(true);
    try {
      const r = await api.put(`/processes/${process.id}`, { ...editForm, brandId: process.brandId });
      onUpdated(r.data); setShowEdit(false); toast.success('Proceso actualizado');
    } catch { toast.error('Error al guardar'); }
    finally { setSaving(false); }
  };

  useEffect(() => {
    const fetchCards = async () => {
      try {
        const r = await api.get(`/processes/${process.id}`);
        setCards(r.data.cards || []);
      } catch {}
    };
    fetchCards();
  }, [process.id]);

  const addCard = async () => {
    try {
      const r = await api.post(`/processes/${process.id}/cards`, { type: 'POST_ESTATICO' });
      setCards(prev => [...prev, r.data]);
      toast.success('Ficha agregada');
    } catch { toast.error('Error al agregar ficha'); }
  };

  const updateCard = (updated: any) => setCards(prev => prev.map(c => c.id === updated.id ? updated : c));

  const deleteCard = async (id: string) => {
    if (!window.confirm('¿Eliminar esta ficha?')) return;
    try {
      await api.delete(`/processes/cards/${id}`);
      setCards(prev => prev.filter(c => c.id !== id));
      toast.success('Ficha eliminada');
    } catch { toast.error('Error al eliminar'); }
  };

  const approveCard = async (cardId: string) => {
    try {
      const r = await api.post(`/processes/cards/${cardId}/approve`);
      setCards(prev => prev.map(c => c.id === cardId ? { ...c, status: 'APROBADO' } : c));
      toast.success(r.data.scheduled ? '✓ Ficha aprobada y programada' : '✓ Ficha aprobada');
    } catch { toast.error('Error al aprobar ficha'); }
  };

  const changeStatus = async (newStatus: string) => {
    try {
      await api.put(`/processes/${process.id}/status`, { status: newStatus });
      setStatus(newStatus);
      onUpdated({ ...process, status: newStatus });
      toast.success('Estado actualizado');
    } catch { toast.error('Error al cambiar estado'); }
  };

  const scheduleAll = async () => {
    setScheduling(true);
    try {
      const r = await api.post(`/processes/${process.id}/schedule`);
      toast.success(`${r.data.created} publicación(es) programadas en el Calendario`);
    } catch { toast.error('Error al programar'); }
    finally { setScheduling(false); }
  };

  const approve = async () => {
    if (!window.confirm('Al aprobar se crearán automáticamente las piezas en el módulo de Contenido. ¿Continuar?')) return;
    setApproving(true);
    try {
      const r = await api.post(`/processes/${process.id}/approve`);
      setStatus(r.data.status);
      onUpdated({ ...process, status: r.data.status });
      toast.success('Proceso aprobado — piezas creadas en Contenido');
    } catch (e: any) { toast.error(e?.response?.data?.error || 'Error al aprobar'); }
    finally { setApproving(false); }
  };

  const nextStatuses: any = {
    BORRADOR: ['REVISION_INTERNA'],
    REVISION_INTERNA: ['APROBADO_INTERNO','BORRADOR'],
    APROBADO_INTERNO: ['REVISION_CLIENTE','REVISION_INTERNA'],
    REVISION_CLIENTE: [],
    APROBADO: ['EN_PRODUCCION'],
    EN_PRODUCCION: ['COMPLETADO'],
  };

  return (<>
    <div>
      {/* Header */}
      <div style={{display:'flex',alignItems:'center',gap:'12px',marginBottom:'20px'}}>
        <button onClick={onBack} style={{width:'32px',height:'32px',borderRadius:'8px',border:'1px solid rgba(15,42,74,0.12)',background:'white',cursor:'pointer',display:'flex',alignItems:'center',justifyContent:'center',fontSize:'16px',color:'#0f2a4a'}}>←</button>
        <div style={{flex:1}}>
          <div style={{display:'flex',alignItems:'center',gap:'10px'}}>
            <h1 style={{margin:0,fontSize:'20px',fontWeight:800,color:'#0f2a4a'}}>{process.name}</h1>
            {process.campaign && <span style={{padding:'3px 10px',borderRadius:'6px',background:'rgba(38,136,201,0.1)',color:'#2688c9',fontSize:'11px',fontWeight:700}}>{process.campaign}</span>}
          </div>
          <div style={{fontSize:'12px',color:'rgba(15,42,74,0.4)',marginTop:'3px'}}>
            {process.brand?.name} · {MONTHS[process.month-1]} {process.year} · {cards.length} fichas
          </div>
        </div>
        <span style={{padding:'5px 14px',borderRadius:'8px',background:`${color}18`,color,fontSize:'12px',fontWeight:700}}>{PROCESS_STATUS_LABEL[status]||status}</span>
        {isAdmin && (<>
          <button onClick={()=>setShowEdit(true)} style={{padding:'7px 14px',borderRadius:'8px',border:'1px solid rgba(15,42,74,0.12)',background:'white',color:'#0f2a4a',fontSize:'12px',fontWeight:600,cursor:'pointer',fontFamily:'"Montserrat",sans-serif'}}>✏️ Editar</button>
          <button onClick={()=>setShowDeleteConfirm(true)} style={{padding:'7px 14px',borderRadius:'8px',border:'none',background:'#fef2f2',color:'#ef4444',fontSize:'12px',fontWeight:700,cursor:'pointer',fontFamily:'"Montserrat",sans-serif'}}>🗑️ Eliminar</button>
        </>)}
        {isAdmin && isAlejandra && (
          <div style={{
            marginLeft: process.materialsLink ? '0' : 'auto',
            padding: '8px 16px',
            borderRadius: '10px',
            background: 'rgba(2,132,199,0.08)',
            border: '1px solid rgba(2,132,199,0.2)',
            color: '#0284c7',
            fontSize: '12px',
            fontWeight: 800,
            display: 'flex',
            alignItems: 'center',
            gap: '6px',
            fontFamily: '"Montserrat", sans-serif'
          }}>
            <span>📊 Modo Contabilidad & Métricas — Aprobación operativa asignada a Dirección/Producción</span>
          </div>
        )}
      </div>

      {/* Documento estratégico */}
      <StrategyDocument process={process} isAdmin={isAdmin} userRole={userRole} userId={userId} userName={userName}/>

      {/* Acciones de estado */}
      {isAdmin && nextStatuses[status]?.length > 0 && (
        <div style={{background:'white',borderRadius:'12px',padding:'14px 16px',marginBottom:'16px',display:'flex',gap:'8px',alignItems:'center',border:'1px solid rgba(15,42,74,0.07)'}}>
          <span style={{fontSize:'12px',color:'rgba(15,42,74,0.5)',fontWeight:600}}>Cambiar estado:</span>
          {nextStatuses[status].map((s: string) => (
            <button key={s} onClick={() => changeStatus(s)}
              style={{padding:'6px 14px',borderRadius:'8px',border:'none',background:`${PROCESS_STATUS_COLOR[s]}18`,color:PROCESS_STATUS_COLOR[s],fontSize:'11px',fontWeight:700,cursor:'pointer',fontFamily:'"Montserrat",sans-serif'}}>
              → {PROCESS_STATUS_LABEL[s]}
            </button>
          ))}
        </div>
      )}

      {/* Botón programar publicaciones — proceso aprobado */}
      {status === 'APROBADO' && isAdmin && (
        <div style={{background:'#eff6ff',border:'1px solid #bfdbfe',borderRadius:'12px',padding:'14px 16px',marginBottom:'16px',display:'flex',justifyContent:'space-between',alignItems:'center'}}>
          <div>
            <div style={{fontSize:'13px',fontWeight:700,color:'#1e40af'}}>Proceso aprobado</div>
            <div style={{fontSize:'11px',color:'#1e40af',opacity:0.7,marginTop:'2px'}}>Programa las fichas con fecha, hora y caption en el Calendario</div>
          </div>
          <button onClick={scheduleAll} disabled={scheduling}
            style={{padding:'9px 20px',borderRadius:'10px',border:'none',background:'#2688c9',color:'white',fontSize:'13px',fontWeight:700,cursor:'pointer',fontFamily:'"Montserrat",sans-serif',opacity:scheduling?0.7:1}}>
            {scheduling ? 'Programando...' : '📅 Programar publicaciones'}
          </button>
        </div>
      )}

      {/* Botón aprobar cliente */}
      {(userRole === 'CLIENTE' || userRole === 'ADMIN') && status === 'REVISION_CLIENTE' && (
        <div style={{background:'#f0fdf4',border:'1px solid #86efac',borderRadius:'12px',padding:'14px 16px',marginBottom:'16px',display:'flex',justifyContent:'space-between',alignItems:'center'}}>
          <div>
            <div style={{fontSize:'13px',fontWeight:700,color:'#166534'}}>Proceso listo para aprobación</div>
            <div style={{fontSize:'11px',color:'#166534',opacity:0.8,marginTop:'2px'}}>Al aprobar se crearán las piezas automáticamente en Contenido</div>
          </div>
          <button onClick={approve} disabled={approving}
            style={{padding:'9px 20px',borderRadius:'10px',border:'none',background:'#10b981',color:'white',fontSize:'13px',fontWeight:700,cursor:'pointer',fontFamily:'"Montserrat",sans-serif',opacity:approving?0.7:1}}>
            {approving ? 'Aprobando...' : '✓ Aprobar proceso'}
          </button>
        </div>
      )}

      {/* Lista fichas */}
      <div style={{display:'flex',flexDirection:'column',gap:'10px'}}>
        {cards.map(card => (
          <div key={card.id} id={'card-'+card.id}>
            <FichaCard card={card} isAdmin={isAdmin} userRole={userRole} onUpdate={updateCard} onDelete={deleteCard} onApprove={approveCard}/>
          </div>
        ))}
        {isAdmin && (
          <button onClick={addCard}
            style={{padding:'12px',borderRadius:'12px',border:'2px dashed rgba(38,136,201,0.3)',background:'rgba(38,136,201,0.03)',color:'#2688c9',fontSize:'13px',fontWeight:700,cursor:'pointer',fontFamily:'"Montserrat",sans-serif',transition:'all 0.15s'}}
            onMouseEnter={e=>(e.currentTarget as any).style.background='rgba(38,136,201,0.08)'}
            onMouseLeave={e=>(e.currentTarget as any).style.background='rgba(38,136,201,0.03)'}>
            + Agregar ficha
          </button>
        )}
        {cards.length === 0 && !isAdmin && (
          <div style={{textAlign:'center',padding:'40px',color:'rgba(15,42,74,0.3)',fontSize:'14px'}}>Sin fichas en este proceso</div>
        )}
      </div>
    </div>
    {showDeleteConfirm && (
      <div style={{position:'fixed',inset:0,background:'rgba(0,0,0,0.45)',display:'flex',alignItems:'center',justifyContent:'center',zIndex:1000}} onClick={()=>setShowDeleteConfirm(false)}>
        <div style={{background:'white',borderRadius:'16px',padding:'28px',width:'360px',textAlign:'center'}} onClick={e=>e.stopPropagation()}>
          <div style={{fontSize:'36px',marginBottom:'12px'}}>🗑️</div>
          <h2 style={{margin:'0 0 8px',fontSize:'17px',fontWeight:800,color:'#111'}}>Eliminar proceso</h2>
          <p style={{margin:'0 0 20px',fontSize:'13px',color:'#6b7280'}}>¿Seguro que deseas eliminar <strong>{process.name}</strong>? Se eliminarán todas sus fichas.</p>
          <div style={{display:'flex',gap:'10px',justifyContent:'center'}}>
            <button onClick={handleDelete} disabled={deleting} style={{padding:'10px 24px',borderRadius:'9px',border:'none',background:'#ef4444',color:'white',fontWeight:700,fontSize:'13px',cursor:'pointer',fontFamily:'inherit',opacity:deleting?0.7:1}}>{deleting?'Eliminando...':'Sí, eliminar'}</button>
            <button onClick={()=>setShowDeleteConfirm(false)} style={{padding:'10px 24px',borderRadius:'9px',border:'1px solid #e2e8f0',background:'white',color:'#6b7280',fontWeight:600,fontSize:'13px',cursor:'pointer',fontFamily:'inherit'}}>Cancelar</button>
          </div>
        </div>
      </div>
    )}
    {showEdit && (
      <div style={{position:'fixed',inset:0,background:'rgba(0,0,0,0.45)',display:'flex',alignItems:'center',justifyContent:'center',zIndex:1000}} onClick={()=>setShowEdit(false)}>
        <div style={{background:'white',borderRadius:'16px',padding:'28px',width:'400px'}} onClick={e=>e.stopPropagation()}>
          <h2 style={{margin:'0 0 20px',fontSize:'16px',fontWeight:800,color:'#0f2a4a'}}>Editar proceso</h2>
          <div style={{display:'flex',flexDirection:'column',gap:'12px'}}>
            <div>
              <label style={{fontSize:'10px',fontWeight:700,color:'rgba(15,42,74,0.5)',display:'block',marginBottom:'4px'}}>NOMBRE</label>
              <input value={editForm.name} onChange={e=>setEditForm(f=>({...f,name:e.target.value}))} style={{width:'100%',padding:'9px',borderRadius:'8px',border:'1px solid rgba(15,42,74,0.12)',fontSize:'13px',fontFamily:'"Montserrat",sans-serif',boxSizing:'border-box'}}/>
            </div>
            <div>
              <label style={{fontSize:'10px',fontWeight:700,color:'rgba(15,42,74,0.5)',display:'block',marginBottom:'4px'}}>CAMPAÑA (opcional)</label>
              <input value={editForm.campaign} onChange={e=>setEditForm(f=>({...f,campaign:e.target.value}))} style={{width:'100%',padding:'9px',borderRadius:'8px',border:'1px solid rgba(15,42,74,0.12)',fontSize:'13px',fontFamily:'"Montserrat",sans-serif',boxSizing:'border-box'}}/>
            </div>
            <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:'10px'}}>
              <div>
                <label style={{fontSize:'10px',fontWeight:700,color:'rgba(15,42,74,0.5)',display:'block',marginBottom:'4px'}}>MES</label>
                <select value={editForm.month} onChange={e=>setEditForm(f=>({...f,month:Number(e.target.value)}))} style={{width:'100%',padding:'9px',borderRadius:'8px',border:'1px solid rgba(15,42,74,0.12)',fontSize:'12px',fontFamily:'"Montserrat",sans-serif'}}>
                  {MONTHS.map((m,i)=><option key={i+1} value={i+1}>{m}</option>)}
                </select>
              </div>
              <div>
                <label style={{fontSize:'10px',fontWeight:700,color:'rgba(15,42,74,0.5)',display:'block',marginBottom:'4px'}}>AÑO</label>
                <input type="number" value={editForm.year} onChange={e=>setEditForm(f=>({...f,year:Number(e.target.value)}))} style={{width:'100%',padding:'9px',borderRadius:'8px',border:'1px solid rgba(15,42,74,0.12)',fontSize:'13px',fontFamily:'"Montserrat",sans-serif',boxSizing:'border-box'}}/>
              </div>
            </div>
          </div>
          <div style={{display:'flex',gap:'10px',justifyContent:'flex-end',marginTop:'20px'}}>
            <button onClick={()=>setShowEdit(false)} style={{padding:'9px 20px',borderRadius:'9px',border:'1px solid #e2e8f0',background:'white',color:'#6b7280',fontWeight:600,fontSize:'13px',cursor:'pointer',fontFamily:'inherit'}}>Cancelar</button>
            <button onClick={handleEdit} disabled={saving} style={{padding:'9px 24px',borderRadius:'9px',border:'none',background:'linear-gradient(135deg,#1e6fa8,#2688c9)',color:'white',fontWeight:700,fontSize:'13px',cursor:'pointer',fontFamily:'inherit',opacity:saving?0.7:1}}>{saving?'Guardando...':'Guardar'}</button>
          </div>
        </div>
      </div>
    )}
  </>);
};


// ── Página principal ──────────────────────────────────────────────────
const ProcessesPage: React.FC = () => {
  const { user } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();
  const isAdmin = user?.role !== 'CLIENTE';
  const userRole = user?.role || '';

  const [processes, setProcesses] = useState<any[]>([]);
  const [brands, setBrands] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const [selected, setSelected] = useState<any>(null);
  const [showCreate, setShowCreate] = useState(false);
  const [search, setSearch] = useState('');
  const [filterStatus, setFilterStatus] = useState('');
  const [filterBrand, setFilterBrand] = useState('');

  useEffect(() => { fetchProcesses(); fetchBrands(); }, []);

  const fetchBrands = async () => {
    try { const r = await api.get('/brands'); setBrands(r.data); } catch {}
  };

  const [pendingOpenId, setPendingOpenId] = useState<string | null>(null);
  const [pendingOpenCardId, setPendingOpenCardId] = useState<string | null>(null);
  
  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const queryProcessId = searchParams.get("processId") || searchParams.get("id");
    const queryCardId = searchParams.get("cardId");
    const stateOpenId = (location.state as any)?.openProcessId || queryProcessId;
    const stateOpenCardId = (location.state as any)?.openCardId || queryCardId;

    if (stateOpenId) {
      setPendingOpenId(stateOpenId);
      if (stateOpenCardId) setPendingOpenCardId(stateOpenCardId);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.search, location.state]);

  useEffect(() => {
    if (!pendingOpenId || processes.length === 0) return;
    const found = processes.find((p: any) => p.id === pendingOpenId);
    if (found) { setSelected(found); setPendingOpenId(null); }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pendingOpenId, processes]);

  const fetchProcesses = async () => {
    setLoading(true);
    try {
      const r = await api.get('/processes');
      setProcesses(r.data);
    } catch { toast.error('Error al cargar procesos'); }
    finally { setLoading(false); }
  };

  const handleCreated = (p: any) => {
    setProcesses(prev => [p, ...prev]);
    setSelected(p);
    setShowCreate(false);
  };

  const handleUpdated = (updated: any) => {
    setProcesses(prev => prev.map(p => p.id === updated.id ? { ...p, ...updated } : p));
  };

  const filtered = processes.filter(p => {
    const matchSearch = !search || p.name.toLowerCase().includes(search.toLowerCase()) || p.brand?.name.toLowerCase().includes(search.toLowerCase());
    const matchStatus = !filterStatus || p.status === filterStatus;
    const matchBrand = !filterBrand || p.brandId === filterBrand;
    return matchSearch && matchStatus && matchBrand;
  });

  if (selected) {
    const full = processes.find(p => p.id === selected.id) || selected;
    return (
      <div style={{display:'flex',height:'100vh',width:'100vw',overflow:'hidden',background:'#f4f7fb',fontFamily:'"Montserrat",sans-serif'}}>
        <Sidebar/>
        <div style={{flex:1,height:'100vh',overflowY:'auto',padding:'28px 32px',display:'flex',flexDirection:'column'}}>
          {full.type === 'CUADRO_MATERIALES' ? (
            <MaterialsBoardDetail
              process={full}
              isAdmin={isAdmin}
              onBack={() => setSelected(null)}
              onDelete={() => { setProcesses(ps => ps.filter(x => x.id !== selected.id)); setSelected(null); }}
            />
          ) : (
            <ProcessDetail
              process={full}
              isAdmin={isAdmin}
              userRole={userRole}
              onBack={() => setSelected(null)}
              onUpdated={handleUpdated}
              onDelete={() => { setProcesses(ps => ps.filter(x => x.id !== selected.id)); setSelected(null); }}
              openCardId={pendingOpenCardId||undefined}
            />
          )}
        </div>
      </div>
    );
  }

  return (
    <div style={{display:'flex',height:'100vh',width:'100vw',overflow:'hidden',background:'#f4f7fb',fontFamily:'"Montserrat",sans-serif'}}>
      <Sidebar/>
      <div style={{flex:1,height:'100vh',overflowY:'auto',padding:'28px 32px'}}>
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",marginBottom:"24px"}}>
        <div>
          <h1 style={{margin:0,fontSize:"24px",fontWeight:800,color:"#0f2a4a"}}>Procesos</h1>
          <p style={{margin:"4px 0 0",fontSize:"13px",color:"rgba(15,42,74,0.45)"}}>Pipeline de contenido por mes o campaña</p>
        </div>
        {isAdmin && (
          <button onClick={() => setShowCreate(true)}
            style={{display:"flex",alignItems:"center",gap:"8px",padding:"10px 20px",borderRadius:"12px",border:"none",background:"linear-gradient(135deg,#1a5fa8,#2688c9)",color:"white",fontSize:"13px",fontWeight:700,cursor:"pointer",fontFamily:"Montserrat,sans-serif",boxShadow:"0 4px 12px rgba(38,136,201,0.35)"}}>
            + Nuevo proceso
          </button>
        )}
      </div>

      <div style={{display:"flex",gap:"10px",marginBottom:"20px",flexWrap:"wrap"}}>
        <input
          placeholder="Buscar por nombre o marca..."
          value={search}
          onChange={e => setSearch(e.target.value)}
          style={{flex:"1",minWidth:"200px",padding:"10px 14px",borderRadius:"10px",border:"1px solid rgba(15,42,74,0.12)",background:"white",fontSize:"13px",color:"#0f2a4a",fontFamily:"Montserrat,sans-serif",outline:"none"}}
        />
        <select value={filterBrand} onChange={e => setFilterBrand(e.target.value)}
          style={{padding:"10px 14px",borderRadius:"10px",border:"1.5px solid rgba(15,42,74,0.12)",background:"white",fontSize:"13px",fontWeight:600,color:"#0f2a4a",fontFamily:"Montserrat,sans-serif",outline:"none",cursor:"pointer"}}>
          <option value="">Todas las marcas / clientes</option>
          {brands.map(b => <option key={b.id} value={b.id}>{b.name}</option>)}
        </select>
        <select value={filterStatus} onChange={e => setFilterStatus(e.target.value)}
          style={{padding:"10px 14px",borderRadius:"10px",border:"1px solid rgba(15,42,74,0.12)",background:"white",fontSize:"13px",color:"#0f2a4a",fontFamily:"Montserrat,sans-serif",outline:"none",cursor:"pointer"}}>
          <option value="">Todos los estados</option>
          {Object.entries(PROCESS_STATUS_LABEL).map(([k,v]) => <option key={k} value={k}>{v as string}</option>)}
        </select>
      </div>

      {loading ? (
        <div style={{textAlign:"center",padding:"60px",color:"rgba(15,42,74,0.3)",fontSize:"14px"}}>Cargando procesos...</div>
      ) : filtered.length === 0 ? (
        <div style={{textAlign:"center",padding:"60px",color:"rgba(15,42,74,0.3)",fontSize:"14px"}}>
          {processes.length === 0 ? "No hay procesos aún." : "Sin resultados para ese filtro."}
        </div>
      ) : (
        <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(300px,1fr))",gap:"14px"}}>
          {filtered.map(p => {
            const color = PROCESS_STATUS_COLOR[p.status] || "#94a3b8";
            return (
              <div key={p.id} onClick={() => setSelected(p)}
                style={{background:"white",borderRadius:"14px",padding:"18px 20px",border:"1px solid rgba(15,42,74,0.07)",cursor:"pointer",transition:"all 0.15s",boxShadow:"0 2px 8px rgba(15,42,74,0.06)"}}
                onMouseEnter={e => { (e.currentTarget as any).style.transform="translateY(-2px)"; (e.currentTarget as any).style.boxShadow="0 6px 20px rgba(15,42,74,0.1)"; }}
                onMouseLeave={e => { (e.currentTarget as any).style.transform=""; (e.currentTarget as any).style.boxShadow="0 2px 8px rgba(15,42,74,0.06)"; }}>
                <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",marginBottom:"10px"}}>
                  <div style={{flex:1}}>
                    <div style={{fontSize:"14px",fontWeight:800,color:"#0f2a4a",marginBottom:"3px"}}>{p.name}</div>
                    <div style={{fontSize:"11px",color:"rgba(15,42,74,0.45)"}}>
                      {p.brand?.name} · {MONTHS[(p.month||1)-1]} {p.year}
                    </div>
                  </div>

                </div>
                {p.campaign && (
                  <div style={{fontSize:"11px",color:"#2688c9",fontWeight:600,marginBottom:"8px"}}>Campaña: {p.campaign}</div>
                )}
                <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",borderTop:"1px solid rgba(15,42,74,0.06)",paddingTop:"10px",marginTop:"4px"}}>
                  <span style={{fontSize:"11px",color:"rgba(15,42,74,0.4)"}}>{p._count?.cards ?? (p.cards||[]).length} fichas</span>
                  <div style={{display:"flex",alignItems:"center",gap:"8px"}}>
                    <span style={{padding:"3px 8px",borderRadius:"5px",background:`${color}18`,color,fontSize:"10px",fontWeight:700}}>{PROCESS_STATUS_LABEL[p.status]||p.status}</span>
                    <span style={{fontSize:"11px",color:"rgba(15,42,74,0.35)"}}>
                      {new Date(p.createdAt).toLocaleDateString("es-CO",{day:"numeric",month:"short"})}
                    </span>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      )}

      {showCreate && (
        <CreateProcessModal brands={brands} onClose={() => setShowCreate(false)} onCreated={handleCreated}/>
      )}
      </div>
    </div>
  );
};

export default ProcessesPage;
